import {post, postfile, downFile} from './http'
const baseUrl = '/api/admin/starmanager'

// 话题管理列表
export const getTopicList = v => post(`${baseUrl}/getCwKmcStartagsinfo`, v.data, v.success, v.error)
// 新增话题
export const saveTopic = v => post(`${baseUrl}/saveCwKmcStartagsinfo`, v.data, v.success, v.error)
// 删除话题
export const delTopic = v => post(`${baseUrl}/deleteCwKmcStartagsinfo`, v.data, v.success, v.error)
// 公告管理列表
export const getNoticeList = v => post(`${baseUrl}/getCwKmcStarnotesinfo`, v.data, v.success, v.error)
// 新增公告
export const saveNotice = v => post(`${baseUrl}/saveStarnotes`, v.data, v.success, v.error)
// 删除公告
export const delNotice = v => post(`${baseUrl}/updateStarnotes`, v.data, v.success, v.error)
// 用户管理列表
export const getUserList = v => post(`${baseUrl}/getStarmemberinfo`, v.data, v.success, v.error)
// 修改成员角色
export const modifyUserRole = v => post(`${baseUrl}/uploadMeberRole`, v.data, v.success, v.error)
// 星球资料列表
export const getStartInfoList = v => post(`${baseUrl}/getCwKmcStarfileinfo`, v.data, v.success, v.error)

// 置顶资料
export const infoIstop = v => post(`${baseUrl}/updateIstop`, v.data, v.success, v.error)
// 加精资料
export const infoIsgood = v => post(`${baseUrl}/updateIsgood`, v.data, v.success, v.error)
// 删除资料
export const infoDel = v => post(`${baseUrl}/updateStatus`, v.data, v.success, v.error)
// 马甲点赞
export const vestPraise = v => post(`${baseUrl}/pushSubjectPraise`, v.data, v.success, v.error)
// 星球帖子列表
export const getStartPostList = v => post(`${baseUrl}/getCwKmcStarsubjectinfoList`, v.data, v.success, v.error)
// 获取星球帖子栏目列表
export const getColumnList = v => post(`${baseUrl}/getCwKmcStarcolumnsubjectinfo`, v.data, v.success, v.error)
// 置顶帖子
export const postIstop = v => post(`${baseUrl}/updateStarsubjectIstop`, v.data, v.success, v.error)
// 加精帖子
export const postIsgood = v => post(`${baseUrl}/updateStarsubjectIsgood`, v.data, v.success, v.error)
// 删除帖子
export const postDel = v => post(`${baseUrl}/updateStarsubjectStatus`, v.data, v.success, v.error)
// 星球话题查询
export const getStarTagList = v => post(`${baseUrl}/getStarTagList`, v.data, v.success, v.error)
// 待审核用户列表
export const getJoinApplyList = v => post(`${baseUrl}/getCwKmcStarjoinapplyinfo`, v.data, v.success, v.error)
// 处理加入星球结果
export const dealJoinApply = v => post(`${baseUrl}/uploadStarApplyResult`, v.data, v.success, v.error)
// 评论管理列表
export const getCommentList = v => post(`${baseUrl}/getCommentList`, v.data, v.success, v.error)
// 评论管理详情
export const getCommentDetails = v => post(`${baseUrl}/getStarCommentreplyinfo`, v.data, v.success, v.error)
// 评论删除
export const delComment = v => post(`${baseUrl}/updateCommentByStatus`, v.data, v.success, v.error)
// 评论回复
export const saveReplyInfo = v => post(`${baseUrl}/saveCwKmcStarcommentreplyinfo`, v.data, v.success, v.error)
// 星球收入汇总
export const getStarIncome = v => post(`${baseUrl}/getStarIncome`, v.data, v.success, v.error)
// 星球收入表格数据
export const findStarPayOrderList = v => post(`${baseUrl}/findStarPayOrderList`, v.data, v.success, v.error)
// 星球收入导出
export const starPayOrderExportList = v => downFile(`${baseUrl}/starPayOrderExportList`, v.data, v.success, v.error)

// 星球栏目编辑
export const saveCwKmcStarcustomcolumninfo = v => post(`${baseUrl}/saveCwKmcStarcustomcolumninfo`, v.data, v.success, v.error)
// 删除星球栏目

// 星球概况 - 成员数据
export const getStarProfile = v => post(`${baseUrl}/getStarProfile`, v.data, v.success, v.error)
// 星球概况 - 折线图
export const getStarProfileByTime = v => post(`${baseUrl}/getStarProfileByTime`, v.data, v.success, v.error)

// 星球详情接口
export const getStarInfo = v => post(`${baseUrl}/getStarInfo`, v.data, v.success, v.error)
// 编辑星球
export const updateStarInfo = v => post(`${baseUrl}/updateStarInfo`, v.data, v.success, v.error)
// 删除栏目
export const deleteCwKmcStarcustomcolumninfo = v => post(`${baseUrl}/deleteCwKmcStarcustomcolumninfo`, v.data, v.success, v.error)
// 栏目列表
export const getCwKmcStarcustomcolumninfoList = v => post(`${baseUrl}/getCwKmcStarcustomcolumninfoList`, v.data, v.success, v.error)
// 栏目排序
export const updateCwKmcStarcustomcolumninfoIndex = v => post(`${baseUrl}/updateCwKmcStarcustomcolumninfoIndex`, v.data, v.success, v.error)
// 保存资料数据
export const saveCwKmcStarfileinfo = v => post(`${baseUrl}/saveCwKmcStarfileinfo`, v.data, v.success, v.error)
// 资料详情
export const getCwKmcStarfiledetail = v => post(`${baseUrl}/getCwKmcStarfiledetail`, v.data, v.success, v.error)

// 保存或编辑马甲
export const saveAndUpdateStarsockpuppet = v => post(`${baseUrl}/saveAndUpdateStarsockpuppet`, v.data, v.success, v.error)
// 保存马甲资料
export const saveStarsockpuppetFile = v => post(`${baseUrl}/saveStarsockpuppetFile`, v.data, v.success, v.error)

// 保存马甲文章
export const saveStarsockpuppetSubject = v => post(`${baseUrl}/saveStarsockpuppetSubject`, v.data, v.success, v.error)
// 马甲列表
export const findStarsockpuppetList = v => post(`${baseUrl}/findStarsockpuppetList`, v.data, v.success, v.error)
// 马甲列表 下拉
export const findAllStarsockpuppet = v => post(`${baseUrl}/findAllStarsockpuppet`, v.data, v.success, v.error)
// 删除马甲
export const deleteStarsockpuppet = v => post(`${baseUrl}/deleteStarsockpuppet`, v.data, v.success, v.error)
// 马甲详情
export const getSockpuppet = v => post(`${baseUrl}/getSockpuppet`, v.data, v.success, v.error)
// 保存社区主题数据
export const saveCwKmcStarsubjectinfo = v => post(`${baseUrl}/saveCwKmcStarsubjectinfo`, v.data, v.success, v.error)
// 基础数据-顶部统计
export const getAboveData = v => post(`${baseUrl}/getAboveData`, v.data, v.success, v.error)
// 基础数据-折线图
export const getBasicData = v => post(`${baseUrl}/getBasicData`, v.data, v.success, v.error)
// 星球数据-顶部统计
export const getStartAboveData = v => post(`${baseUrl}/getStartAboveData`, v.data, v.success, v.error)
// 星球数据-折线图
export const getStartData = v => post(`${baseUrl}/getStartData`, v.data, v.success, v.error)
// 用户数据-顶部统计
export const getUsersAboveData = v => post(`${baseUrl}/getStartUsersAboveData`, v.data, v.success, v.error)
// 用户数据-折线图
export const getUserData = v => post(`${baseUrl}/getStartUsersData`, v.data, v.success, v.error)
// 获取评论列表回复信息
export const getStarCommentreplyinfo = v => post(`${baseUrl}/getStarCommentreplyinfo`, v.data, v.success, v.error)
// 回复详情列表
export const getStarsubjectdetail = v => post(`${baseUrl}/getStarsubjectdetail`, v.data, v.success, v.error)
// 保存回复数据
export const saveCwKmcStarcommentreplyinfo = v => post(`${baseUrl}/saveCwKmcStarcommentreplyinfo`, v.data, v.success, v.error)
// 帖子详情用户回复列表
export const getCwKmcStarcommentreplyinfo = v => post(`${baseUrl}/getCwKmcStarcommentreplyinfo`, v.data, v.success, v.error)
// 保存评论数据
export const saveCwKmcStarcommentinfo = v => post(`${baseUrl}/saveCwKmcStarcommentinfo`, v.data, v.success, v.error)
// 删除评论
export const deleteCwKmcStarcommentinfo = v => post(`${baseUrl}/deleteCwKmcStarcommentinfo`, v.data, v.success, v.error)
// 星球栏目
export const getCwKmcStarcolumnsubjectinfo = v => post(`${baseUrl}/getCwKmcStarcolumnsubjectinfo`, v.data, v.success, v.error)
// 栏目详情
export const getCwKmcStarcustomcolumninfodetail = v => post(`${baseUrl}/getCwKmcStarcustomcolumninfodetail`, v.data, v.success, v.error)